export const EU_COUNTRY_CODE_LIST = ['AT', 'BE', 'BG', 'HR', 'DK', 'EE', 'FI', 'GR', 'HU', 'IE', 'LV', 'LU', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE', 'CZ'];

export const UK_COUNTRY_CODE = 'GB'; // 英国

export const FR_COUNTRY_CODE = 'FR'; // 法国

export const DE_COUNTRY_CODE = 'DE'; // 德国

export const IT_COUNTRY_CODE = 'IT'; // 意大利

export const ES_COUNTRY_CODE = 'ES'; // 西班牙

export const UA_COUNTRY_CODE = 'UA'; // 乌克兰

// 0 通知 1消息中心 2 banner 3 文章
export const SOURCE_FROM_LIST = ['app_push', 'notifications_detail', 'profile_banner', 'space_article'];

export const MICRO_INVERTER_LANDING_CPUNTRY_LIST = ['us', 'fr', 'de', 'it', 'es'];

export const MICRO_INVERTER_LANDING_DISTRICT = 'eu';

type GTMID = {
    [key: string]: string;
};

export const GTM_ID: GTMID = {
    US: 'GTM-PMPQLNN',
    EN: 'GTM-PMPQLNN',
    JP: 'GTM-PDR8N7V',
    CA: 'GTM-M9TGLZ2',
    UK: 'GTM-TKM9J9C',
    AU: 'GTM-T8LK4VN',
    FR: 'GTM-M8GKLX5',
    DE: 'GTM-MXK5BQ2',
    EU: 'GTM-W3QRM8L',
    KR: 'GTM-TPSBKB2',
    ES: 'GTM-NRWKJ9R',
    IT: 'GTM-KXRK7C7',
    CN: 'GTM-TW73XTD',
    ZA: 'GTM-KV9HHJM',
};

export type BundleKey = 'NoStorageKit' | '2kWhStorageKit' | '1kWhStorageKit' | 'CustomiseforYourHome';

export type CountryKey = 'DE' | 'FR' | 'EU' | 'IT' | 'ES' | 'UK';

type ShopBundleMap = {
    [Key in BundleKey]: {
        [Key in CountryKey]: string;
    };
};

export const SHOP_BOUNDLE_MAP: ShopBundleMap = {
    NoStorageKit: {
        DE: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        FR: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        EU: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        IT: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        ES: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        UK: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46662362431827&bundle=battery-ready&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
    },
    '2kWhStorageKit': {
        DE: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        FR: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        EU: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        IT: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        ES: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        UK: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46662362431827&bundle=advanced-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
    },
    '1kWhStorageKit': {
        DE: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        FR: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        EU: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        IT: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        ES: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        UK: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46662362431827&bundle=starter-kit&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
    },
    CustomiseforYourHome: {
        DE: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        FR: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        EU: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        IT: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        ES: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
        UK: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=diy&utm_source=app_page&utm_medium=app&utm_campaign=powerstream&utm_content=launch_ef',
    },
};
